import CommonCard from "./CommonCard";
import { TaxCalculations } from "../../../model/tax_calculations";

const CityBalanceSummary = ({ taxBreakdown }: { taxBreakdown: TaxCalculations}) => {
  const star = Math.abs(taxBreakdown.final_balance) <= import.meta.env.VITE_APP_SAAS_CUSTOMER_PAYMENT_THRESHOLD;
  const summary = {
    title: "Your Final Result",
    cardDescription: "",
    options: {
      "Springboro Tax": taxBreakdown.tax_liability,
      "Total Credits": taxBreakdown.total_credits,
      [`Balance Due${star ? ' *' : ''}`]: taxBreakdown.final_balance,
    },
  };

  return (
    <CommonCard cardDetails={summary} bold={[2]} level={1} />
  );
}

export default CityBalanceSummary;
